function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 389 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154658",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.741 7.662 8.017.09A.37.37 0 0 0 7.775 0H5.731a.184.184 0 0 0-.12.323l8.089 7.02H.185A.185.185 0 0 0 0 7.528v1.385a.185.185 0 0 0 .185.187H13.7l-8.087 7.02a.184.184 0 0 0 .12.323h2.109a.177.177 0 0 0 .12-.046l8.779-7.616a.74.74 0 0 0 0-1.118z",
    transform: "translate(1.502 1.779)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMCheckout);
export default __webpack_public_path__ + "static/media/m_checkout.cbff5d885ef2edcefe4ddf4341060ef2.svg";
export { ForwardRef as ReactComponent };